export const CHECKOUT = {
    INVOICE: 'Boleto / PIX',
    CREDIT_CARD: 'Cartão de Crédito',
    ANNUAL_PLAN: 'Plano Anual',
};
